<template>
  <v-menu
    v-model="datepickerOpen"
    :close-on-content-click="false"
    transition="scale-transition"
    offset-y
    offset-overflow
    min-width="auto"
  >
    <template v-slot:activator="{ on }">
      <v-text-field
        prepend-icon="mdi-calendar"
        v-model="formatedDate"
        v-mask="dateMask"
        :label="label"
        :hint="`Enter date in ${format} format `"
        v-bind="$attrs"
        v-on="on"
      />
    </template>
    <v-date-picker
      v-model="isoDate"
      no-title
      @input="datepickerOpen = false"
      v-bind="$attrs"
    />
  </v-menu>

</template>
<script>
import dayjs from 'dayjs'

import { ISO_DATE_FORMAT } from '@/helpers'

export default {
  name: 'VfDateInput',
  props: {
    value: {
      type: [String, Date],
      default () {
        return null
      }
    },
    label: {
      type: String,
      default: ''
    },
    format: {
      type: String,
      default: ISO_DATE_FORMAT
    }
  },
  data () {
    return {
      isoDate: this.value ? dayjs(this.value).format(ISO_DATE_FORMAT) : null,
      datepickerOpen: false
    }
  },
  computed: {
    dateMask () {
      return this.format
        .split(/([-./])/g)
        .map((part) => {
          switch (part) {
            case 'YYYY':
              return [/2/, /[0-1]/, /\d/, /\d/]
            case 'MM':
              return [/[0-1]/, /\d/]
            case 'DD':
              return [/[0-3]/, /\d/]
            default:
              return part
          }
        })
        .flat()
    },
    formatedDate: {
      set (value) {
        const parsedDate = dayjs(value, this.format)
        if (parsedDate.isValid()) {
          this.isoDate = parsedDate.format(ISO_DATE_FORMAT)
        } else {
          this.isoDate = null
        }
      },
      get () {
        const parsedDate = dayjs(this.isoDate, this.format)
        return this.isoDate
          ? parsedDate.isValid() ? parsedDate.format(this.format) : ''
          : this.isoDate
      }
    }
  },
  watch: {
    isoDate (value) {
      this.$emit('input', value)
    },
    value (value) {
      this.isoDate = this.value
        ? dayjs(this.value).format(ISO_DATE_FORMAT)
        : null
      // this.formatedDate = dayjs(value).format(this.format)
    }
  },
  methods: {}
}
</script>
